import { fetchToken } from "../../../common/FetchCookie"
import { BASE_URL, EMPLOYER, EMPLOYER_SUBSCRIPTIONS_ACTIVE } from "../../../common/URLs"


export const fetchEmployerActiveSubscription = async () => {
    const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SUBSCRIPTIONS_ACTIVE}`
    try {
        const token = await fetchToken()
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            }
        })
        const data = await response.json();
        return data;
    } catch (error) {
        return error
    }
}